import {Tab, Tabs, Typography} from "@mui/material";
import React from "react";
import { withStyles } from 'tss-react/mui';


export const VerticalTabs = withStyles(Tabs, theme => ({
  flexContainer: {
    flexDirection: 'column' as const
  },
  indicator: {
    display: 'none',
  }
}));


export const MyTab = withStyles(Tab, theme => ({
  selected: {
    color: 'tomato',
    borderBottom: '2px solid tomato'
  }
}));


export function TabContainer(props: any) {
  return (
    <Typography component="div" style={{ padding: '0 24px', flex: 1 }}>
      {props.children}
    </Typography>
  );
}